export default function getAddressLabel(address) {
	if (!address) return '';

	const base = `${address.telepulesNev}, ${address.utca} ${address.hazSzam}.`;
	const floor = address.emelet ? `, ${address.emelet} emelet` : '';
	const door = address.ajto ? `, ${address.ajto} ajtó` : '';

	return base + floor + door;
}



// WEBPACK FOOTER //
// ../source/common/utils/get-address-label.js